import svgPaths from '@/imports/svg-srfw3kyqh8';
import { type PaymentMethodTranslations } from './types';

interface PaymentMethodHeaderProps {
  t: PaymentMethodTranslations;
  onBack: () => void;
}

export function PaymentMethodHeader({ t, onBack }: PaymentMethodHeaderProps) {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-primary h-[50px]">
      <div className="flex items-center justify-center relative h-[50px] px-[20px]">
        <button
          onClick={onBack}
          className="absolute left-[20px] flex items-center justify-center w-[32px] h-[32px]"
        >
          <svg className="w-[12px] h-[21px]" fill="none" preserveAspectRatio="none" viewBox="0 0 12 21">
            <path d={svgPaths.p27596280} fill="white" />
          </svg>
        </button>
        <h1 className="font-['Noto_Sans:Bold',_'Noto_Sans_KR:Bold',_sans-serif] font-bold text-[16px] text-white tracking-[-0.32px] text-center uppercase" style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}>
          {t.title}
        </h1>
      </div>
    </div>
  );
}
